// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"48":"73495e","96":"3fd9ed","687":"f4e416","869":"4c11e0","922":"84c9af"}[chunkId] + ".css";
};